import { render, staticRenderFns } from "./addNewUserDialog.vue?vue&type=template&id=2be02d9d&"
import script from "./addNewUserDialog.vue?vue&type=script&lang=js&"
export * from "./addNewUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports